import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import categoriesReducer from "../features/categories/categoriesSlice";
import bookingFlowReducer from "../features/booking/bookingFlowSlice";
import bookingsReducer from "../features/bookings/bookingsSlice";
import providerReducer from "../features/provider/providerSlice";
import addressesReducer from "../features/addresses/addressesSlice";
import adminReducer from "../features/admin/adminSlice";
import { analyticsMiddleware } from "../analytics/middleware";
import { injectStore } from "../services/api";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    categories: categoriesReducer,
    bookingFlow: bookingFlowReducer,
    bookings: bookingsReducer,
    provider: providerReducer,
    addresses: addressesReducer,
    admin: adminReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(analyticsMiddleware),
});

// Inject the store into the api module to break the circular dependency
injectStore(store);
